import { forwardRef as o, useMemo as e } from "react";
import { j as n } from "./radix-common-Dx8bZddK.js";
import { w as h } from "./uniqueSvgIds-KQABKtm8.js";
import './Tick.css';function L(t) {
  var C, r, s = "";
  if (typeof t == "string" || typeof t == "number") s += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var c = t.length;
    for (C = 0; C < c; C++) t[C] && (r = L(t[C])) && (s && (s += " "), s += r);
  } else for (r in t) t[r] && (s && (s += " "), s += r);
  return s;
}
function d() {
  for (var t, C, r = 0, s = "", c = arguments.length; r < c; r++) (t = arguments[r]) && (C = L(t)) && (s && (s += " "), s += C);
  return s;
}
const x = "sb-ui-base__vJHhl", j = {
  base: x
}, i = /* @__PURE__ */ o(function({
  size: C,
  children: r,
  className: s,
  style: c,
  title: l,
  ...u
}, a) {
  const f = e(() => C != null ? Object.assign({
    width: typeof C == "string" ? C : `${C / 16}rem`,
    height: typeof C == "string" ? C : `${C / 16}rem`,
    verticalAlign: "middle"
  }, c) : c ?? {}, [C, c]);
  return /* @__PURE__ */ n.jsxs("svg", {
    ref: a,
    viewBox: "0 0 36 36",
    fill: "none",
    stroke: "none",
    style: f,
    className: d("sb-ui-icon", j.base, s),
    "aria-hidden": !0,
    ...u,
    children: [l && /* @__PURE__ */ n.jsx("title", {
      children: l
    }), e(() => h(r), [r])]
  });
}), H = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M7.50586 2.99175C7.50586 2.67996 7.62711 2.40528 7.86467 2.16277L9.66863 0.358812C9.90619 0.121254 10.1833 0 10.4951 0C10.8069 0 11.0816 0.121254 11.3241 0.358812L28.1363 17.171C28.3739 17.4135 28.4951 17.6882 28.4951 18C28.4951 18.3118 28.3739 18.5889 28.1363 18.829L11.3241 35.6412C11.0866 35.8787 10.8069 36 10.4951 36C10.1833 36 9.90619 35.8787 9.66616 35.6412L7.86715 33.8372C7.62959 33.5947 7.50833 33.32 7.50833 33.0082C7.50833 32.6965 7.62959 32.4218 7.86715 32.1793L22.0439 18.0025L7.86715 3.82568C7.62959 3.58812 7.50833 3.31097 7.50833 2.99917V2.98928L7.50586 2.99175Z",
      fill: "currentColor"
    })
  });
}), V = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M18 0C27.9414 0 36 8.0586 36 18C36 27.9414 27.9414 36 18 36C8.0586 36 0 27.9414 0 18C0 8.0586 8.0586 0 18 0ZM18 2.5884C9.4914 2.5992 2.5974 9.4932 2.5866 18.0018C2.5866 26.514 9.4878 33.4152 18 33.4152C26.5122 33.4152 33.4134 26.514 33.4134 18.0018C33.4134 9.4896 26.5122 2.5884 18 2.5884ZM11.493 10.1214C11.8746 10.1214 12.2184 10.2762 12.4668 10.5264L18 16.0596L23.5332 10.5264C23.7816 10.2816 24.1218 10.1286 24.4998 10.1286C25.2576 10.1286 25.8714 10.7424 25.8714 11.5002C25.8714 11.8764 25.7202 12.2184 25.4736 12.4668L19.9404 18L25.4736 23.5332C25.7184 23.7816 25.8714 24.1218 25.8714 24.4998C25.8714 25.2576 25.2576 25.8714 24.4998 25.8714C24.1236 25.8714 23.7816 25.7202 23.5332 25.4736L18 19.9404L12.4668 25.4736C12.2184 25.7238 11.8728 25.8786 11.493 25.8786C10.7352 25.8786 10.1214 25.2648 10.1214 24.507C10.1214 24.1254 10.2762 23.7816 10.5264 23.5332L16.0596 18L10.5264 12.4668C10.2762 12.2184 10.1214 11.8728 10.1214 11.493C10.1214 10.7352 10.7352 10.1214 11.493 10.1214Z",
      fill: "currentColor"
    })
  });
}), g = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M35.0428 34.466C33.7666 35.7422 31.6978 35.7422 30.4216 34.466L18.2884 22.3328L5.5784 35.0428C4.30217 36.3191 2.2334 36.3191 0.957173 35.0428C-0.319058 33.7666 -0.319058 31.6978 0.957173 30.4216L13.6672 17.7116L1.53401 5.5784C0.257779 4.30217 0.257779 2.23177 1.53401 0.957173C2.81024 -0.319058 4.87901 -0.319058 6.15524 0.957173L18.2884 13.0904L29.8431 1.53564C31.1194 0.259413 33.1881 0.259413 34.4644 1.53564C35.7406 2.81187 35.7406 4.88064 34.4644 6.15687L22.9096 17.7116L35.0428 29.8448C36.3191 31.121 36.3191 33.1898 35.0428 34.466Z",
      fill: "currentColor"
    })
  });
}), m = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M20.4575 0L35.9987 15.5412V20.457L20.4575 35.9982H15.5417L0.000488281 20.457V15.5412L15.5417 0H20.4575ZM19.4171 2.5092H16.5803L2.50789 16.5816V19.4184L16.5803 33.4908H19.4171L33.4895 19.4184V16.5816L19.4171 2.5092ZM19.2983 23.3082V26.37H16.4417V23.3082H19.2983ZM16.0133 9.6318L19.9859 9.657L19.3415 21.4344H16.5083L16.0133 9.6318Z",
      fill: "currentColor"
    })
  });
}), b = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M18 2.5884C26.5122 2.5884 33.4134 9.4896 33.4134 18.0018C33.4134 26.514 26.5122 33.4152 18 33.4152C9.4878 33.4152 2.5866 26.514 2.5866 18.0018C2.5974 9.4932 9.4932 2.5992 18 2.5884ZM18 0C8.0586 0 0 8.0586 0 18C0 27.9414 8.0586 36 18 36C27.9414 36 36 27.9414 36 18C36 8.0586 27.9414 0 18 0ZM18 12.4236C16.1586 12.4236 15.3576 11.6586 15.3576 9.8514C15.3576 8.0784 16.1568 7.3134 18 7.3134C19.8774 7.3134 20.6424 8.0784 20.6424 9.8514C20.6424 11.6586 19.8774 12.4236 18 12.4236ZM15.7752 27.3198V15.3198H20.2248V27.3198H15.7752Z",
      fill: "currentColor"
    })
  });
}), w = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M36 17.55V18.45C36 19.4441 35.1941 20.25 34.2 20.25H1.8C0.805887 20.25 0 19.4441 0 18.45V17.55C0 16.5559 0.805887 15.75 1.8 15.75H34.2C35.1941 15.75 36 16.5559 36 17.55Z",
      fill: "currentColor"
    })
  });
}), v = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M18.45 0C19.4441 0 20.25 0.805887 20.25 1.8V15.75H34.2C35.1941 15.75 36 16.5559 36 17.55V18.45C36 19.4441 35.1941 20.25 34.2 20.25H20.25V34.2C20.25 35.1941 19.4441 36 18.45 36H17.55C16.5559 36 15.75 35.1941 15.75 34.2V20.25H1.8C0.805887 20.25 0 19.4441 0 18.45V17.55C0 16.5559 0.805887 15.75 1.8 15.75H15.75V1.8C15.75 0.805887 16.5559 0 17.55 0H18.45Z",
      fill: "currentColor"
    })
  });
}), y = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M18.0013 25.0884C18.8707 25.0884 19.5799 25.7958 19.5799 26.6688V34.4214C19.5799 35.2962 18.8725 36.0018 18.0013 36.0018C17.1301 36.0018 16.4227 35.2926 16.4227 34.4214V26.6688C16.4227 25.7958 17.1283 25.0884 18.0013 25.0884ZM10.7545 23.0148C11.3737 22.3956 12.3727 22.3956 12.9883 23.0148C13.6057 23.6286 13.6057 24.6312 12.9883 25.2504L7.50551 30.7332C6.89171 31.347 5.89091 31.347 5.27351 30.7278C4.65611 30.1104 4.65611 29.1114 5.27351 28.4958L10.7545 23.0148ZM23.0143 23.0112C23.6299 22.392 24.6307 22.392 25.2481 23.0112L30.7273 28.4958C31.3465 29.1114 31.3465 30.1122 30.7291 30.7314C30.1099 31.3452 29.1145 31.3452 28.4953 30.726L23.0143 25.2468C22.3987 24.6294 22.3987 23.625 23.0143 23.0112ZM9.33071 16.4232C10.2037 16.4232 10.9111 17.1252 10.9111 17.9982C10.9111 18.8712 10.2055 19.5804 9.33071 19.5804H1.57631C0.705112 19.5804 -0.000488281 18.8712 -0.000488281 17.9982C-0.000488281 17.1252 0.705112 16.4232 1.57631 16.4232H9.33071ZM34.4209 16.4232C35.2957 16.4232 36.0013 17.1252 36.0013 17.9982C36.0013 18.8712 35.2939 19.5804 34.4209 19.5804H26.6701C25.7971 19.5804 25.0879 18.8712 25.0879 17.9982C25.0879 17.1252 25.7971 16.4232 26.6701 16.4232H34.4209ZM5.27351 5.2704C5.89091 4.653 6.88631 4.653 7.50551 5.2704L12.9883 10.755C13.6057 11.3688 13.6057 12.3696 12.9883 12.987C12.3727 13.6062 11.3719 13.6062 10.7545 12.9888L5.27351 7.506C4.65611 6.8886 4.65611 5.8896 5.27351 5.2704ZM28.4971 5.2704C29.1127 4.6548 30.1117 4.6548 30.7291 5.2704C31.3483 5.886 31.3483 6.8904 30.7309 7.506L25.2481 12.987C24.6325 13.6044 23.6299 13.6044 23.0143 12.9852C22.3987 12.3678 22.3987 11.367 23.0143 10.7532L28.4971 5.2704ZM18.0013 0C18.8707 0 19.5799 0.7038 19.5799 1.5768V9.333C19.5799 10.2024 18.8725 10.9098 18.0013 10.9098C17.1301 10.9098 16.4227 10.2042 16.4227 9.333V1.5768C16.4227 0.7038 17.1283 0 18.0013 0Z",
      fill: "currentColor"
    })
  });
}), A = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsxs(i, {
    ref: r,
    ...C,
    children: [/* @__PURE__ */ n.jsxs("g", {
      clipPath: "url(#clip0_4631_2956)",
      children: [/* @__PURE__ */ n.jsx("path", {
        d: "M18 2.5884C26.5122 2.5884 33.4134 9.4896 33.4134 18.0018C33.4134 26.514 26.5122 33.4152 18 33.4152C9.4878 33.4152 2.5866 26.514 2.5866 18.0018C2.5974 9.4932 9.4932 2.5992 18 2.5884ZM18 0C8.0586 0 0 8.0586 0 18C0 27.9414 8.0586 36 18 36C27.9414 36 36 27.9414 36 18C36 8.0586 27.9414 0 18 0Z",
        fill: "currentColor"
      }), /* @__PURE__ */ n.jsx("path", {
        d: "M27.7335 11.2244L27.399 10.8899C27.1388 10.6304 26.8223 10.4999 26.451 10.4999C26.0798 10.4999 25.764 10.6304 25.5038 10.8899L14.9993 21.3944L10.1205 16.5149C9.85952 16.2554 9.54377 16.1249 9.17252 16.1249C8.80052 16.1249 8.48402 16.2554 8.22377 16.5157L7.88927 16.8502C7.62977 17.1112 7.49927 17.4269 7.49927 17.7982C7.49927 18.1694 7.62977 18.4852 7.88927 18.7454L13.515 24.7754L13.8495 25.1099C14.1105 25.3694 14.4263 25.4999 14.7975 25.4999C15.1688 25.4999 15.4845 25.3694 15.7448 25.1099L27.7343 13.1212C27.9938 12.8602 28.1243 12.5452 28.1243 12.1732C28.1243 11.8012 27.9938 11.4854 27.7335 11.2244Z",
        fill: "currentColor"
      })]
    }), /* @__PURE__ */ n.jsx("defs", {
      children: /* @__PURE__ */ n.jsx("clipPath", {
        id: "clip0_4631_2956",
        children: /* @__PURE__ */ n.jsx("rect", {
          width: "36",
          height: "36",
          fill: "currentColor"
        })
      })
    })]
  });
}), I = /* @__PURE__ */ o(function(C, r) {
  return /* @__PURE__ */ n.jsx(i, {
    ref: r,
    ...C,
    children: /* @__PURE__ */ n.jsx("path", {
      d: "M35.318 6.21034L34.7341 5.62831C34.2799 5.17678 33.7274 4.94971 33.0794 4.94971C32.4314 4.94971 31.8803 5.17678 31.426 5.62831L13.0909 23.9061L4.57527 15.4158C4.11971 14.9643 3.56858 14.7372 2.92058 14.7372C2.27127 14.7372 1.71884 14.9643 1.26458 15.4171L0.680727 15.9991C0.227782 16.4533 0 17.0027 0 17.6487C0 18.2946 0.227782 18.844 0.680727 19.2969L10.5002 29.7891L11.0841 30.3711C11.5396 30.8226 12.0908 31.0497 12.7388 31.0497C13.3868 31.0497 13.9379 30.8226 14.3921 30.3711L35.3193 9.51068C35.7722 9.05654 36 8.50844 36 7.86116C36 7.21388 35.7722 6.66448 35.318 6.21034Z",
      fill: "currentColor"
    })
  });
});
export {
  H as A,
  V as C,
  m as E,
  b as I,
  w as M,
  v as P,
  A as S,
  I as T,
  g as a,
  y as b,
  d as c,
  i as d
};
//# sourceMappingURL=Tick-CrI49bkm.js.map
